"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotosTimeline = void 0;
/**
 * Provides access to the photo timeline.
 */
class PhotosTimeline {
    apiService;
    photoShares;
    constructor(apiService, photoShares) {
        this.apiService = apiService;
        this.photoShares = photoShares;
        this.apiService = apiService;
        this.photoShares = photoShares;
    }
    async *iterateTimeline(signal) {
        const { volumeId } = await this.photoShares.getOwnVolumeIDs();
        yield* this.apiService.iterateTimeline(volumeId, signal);
    }
}
exports.PhotosTimeline = PhotosTimeline;
//# sourceMappingURL=timeline.js.map